<template>
    <filter-badge-container class="relative"
                            @click="$emit('click')"
                            @mouseover="isHover = true"
                            @mouseleave="isHover = false"
    >
      <slot />
      <div v-if="isHover"
           class="close-button absolute flex h-5 w-5 bg-primary rounded-full text-white text-sm text-center"
           @click.stop="$emit('remove')">
        <cross-icon class="m-auto" />
      </div>
    </filter-badge-container>
</template>

<script>
import FilterBadgeContainer from './FilterBadgeContainer.vue'
import CrossIcon from '@/assets/images/icons/CrossIcon'

export default {
  name: 'CloseableFilterBadgeContainer',

  components: { FilterBadgeContainer, CrossIcon },

  data() {
    return {
      isHover: false
    }
  }
}
</script>

<style scoped>
  .close-button {
    top: -5px;
    right: -5px;
  }
</style>
